export default "__VITE_ASSET__DRmH_Iq9__"